module.exports = __webpack_public_path__ + "static/media/featured-image-tmp.dc7fff8f.png";